import { Button } from "common/components/ui/Button";
import { DialogFooter, DialogHeader } from "common/components/ui/Dialog";
import { DrawerFooter, DrawerHeader } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useLeadListSourceMutations from "../../datahooks/useLeadListSourceMutations";

interface DeleteSourceProps {
  listId: string;
  sourceId: string;
  onBack: () => void;
  onClose: () => void;
}

export default function DeleteSource({
  listId,
  sourceId,
  onBack,
  onClose,
}: DeleteSourceProps) {
  const isDesktop = useTwBreakpoint("lg");
  const { deleteSource, isDeletingSource } = useLeadListSourceMutations();

  function onDelete() {
    deleteSource({ listId, sourceId }).then(() => onClose());
  }

  const Header = isDesktop ? DialogHeader : DrawerHeader;
  const Footer = isDesktop ? DialogFooter : DrawerFooter;

  return (
    <>
      <Header
        title="Delete source?"
        subtitle="Are you sure you want to delete this source?"
        onBack={onBack}
      />

      <Footer className="justify-end">
        <Button
          variant="secondary-black"
          disabled={isDeletingSource}
          onClick={onBack}
        >
          Cancel
        </Button>

        <Button
          variant="outline-danger"
          onClick={onDelete}
          isLoading={isDeletingSource}
        >
          Delete
        </Button>
      </Footer>
    </>
  );
}
